export default function PresentationHero() {
  return (
    <section className="relative min-h-[520px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20professional%20building%20exterior%20Geneva%20Switzerland%20architecture%20clean%20minimalist%20facade%20glass%20steel%20urban%20corporate%20headquarters%20elegant&width=1440&height=520&seq=pres-hero-01&orientation=landscape"
          alt="CasaReNovaPlus Neuenegg"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 py-24">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-brand-500/20 border border-brand-500/40 text-brand-300 text-xs font-semibold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
            <i className="ri-file-pdf-line"></i>
            Plaquette de présentation
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white leading-tight mb-5">
            CasaReNovaPlus<br />
            <span className="text-brand-400">Votre partenaire</span><br />
            rénovation à Neuenegg
          </h1>
          <p className="text-gray-300 text-lg leading-relaxed mb-8">
            Découvrez notre entreprise, nos valeurs et l'ensemble de nos prestations dans notre plaquette de présentation complète. Téléchargez-la ou consultez-la directement en ligne.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="#pdf-viewer"
              className="inline-flex items-center gap-2 bg-brand-500 hover:bg-brand-600 text-white font-semibold px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-eye-line"></i>
              Consulter la plaquette
            </a>
            <a
              href="#pdf-viewer"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              Télécharger le PDF
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
